module.exports = __webpack_public_path__ + "img/editor_preview-1.8bf0c42.webp";